import { type JSXProps } from 'engine/index';
import { DropdownField, Form, PasswordField, SubmitButton, TextField, validator as V } from './FormComponents';
import { FormGroup } from './FormGroup';
import { displayRole, UserCreateSchema, UserUpdateSchema, type UserCreate as UserCreateModel } from 'shared/modelTypes/index';
import { CheckCheck } from 'lucide-static';
import { showToast, Toast } from './Toast';
import { navigate } from 'engine/router';
import { rpc } from 'src/backend';

type UserCreateProps = JSXProps;

export class UserCreate extends Base.Component<UserCreateProps> {
	override render(): HTMLElement {
		const view: HTMLElement = (
			<div class="flex flex-col gap-3">
				<h2 class="text-gray-700 dark:text-gray-300">New User</h2>
				<div class="w-fit rounded-lg bg-white p-6 shadow-md dark:bg-gray-800">
					<Form schema={UserCreateSchema} onSubmit={this.create.bind(this)} class="flex flex-col gap-6">
						<div class="flex flex-col gap-6 md:flex-row">
							<FormGroup>
								<DropdownField
									name="role"
									label="Role"
									value="game-master"
									validator={V(UserUpdateSchema.shape.role)}
									options={UserUpdateSchema.shape.role._def.values.map((k) => ({
										value: k,
										label: displayRole(k),
									}))}
								/>
								<div class="flex flex-col items-stretch gap-4 md:flex-row">
									<TextField
										name="firstName"
										label="First Name"
										validator={V(UserCreateSchema.shape.lastName)}
										placeholder="John"
									/>
									<TextField
										name="lastName"
										label="Last Name"
										validator={V(UserCreateSchema.shape.lastName)}
										placeholder="Doe"
									/>
								</div>
								<TextField
									type="email"
									name="email"
									label="Email"
									validator={V(UserCreateSchema.shape.email)}
									placeholder="johndoe@example.com"
								/>
								<PasswordField
									strengthIndicator
									name="password"
									validator={V(UserCreateSchema.shape.password)}
									label="Password"
								/>
							</FormGroup>
						</div>
						<SubmitButton>Create</SubmitButton>
					</Form>
				</div>
			</div>
		);

		return view;
	}

	async create(user: UserCreateModel) {
		this.view.style.pointerEvents = 'none';
		this.view.style.opacity = '0.6';
		const res = await rpc.createUser.query(user);
		// console.log('got res', res);
		navigate('/dashboard/users');
		showToast(<Toast icon={CheckCheck} title="User created!" />, 3000);
	}
}
